import type { ChatMessage } from '../providers/AIContext';

export function collectFileFolders(messages: ChatMessage[]): string[] {
    const folders: string[] = [];
    for (const msg of messages) {
        for (const att of msg.attachments ?? []) {
            if (att.kind === 'tabular' || att.kind === 'image' || att.kind === 'email') {
                folders.push(att.fileFolder);
            }
        }
    }
    return folders;
}
